enum AuthError {
    userEmailNotConfirmed = 1001,
}

export default AuthError;
